export default "__VITE_ASSET__JpCJc4bI__"